import React from 'react';
import PropTypes from 'prop-types';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { RetryLink } from '@apollo/client/link/retry';

const cache = new InMemoryCache();
const link = new RetryLink();

const client = new ApolloClient({
  cache,
  link,
});

const ReturnsApolloProvider = ({ children }) =>
  client ? <ApolloProvider client={client}>{children}</ApolloProvider> : null;

ReturnsApolloProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ReturnsApolloProvider;
